import { render } from "./PartnerList.vue?vue&type=template&id=57da7373&scoped=true"
import script from "./PartnerList.vue?vue&type=script&lang=js"
export * from "./PartnerList.vue?vue&type=script&lang=js"

import "./PartnerList.vue?vue&type=style&index=0&id=57da7373&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57da7373"]])

export default __exports__